"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var color_1 = __importDefault(require("color"));
var colors_1 = __importDefault(require("../../assets/jss/colors"));
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return (0, core_1.createStyles)({
        container: material_kit_pro_react_1.container,
        coloredShadow: material_kit_pro_react_1.coloredShadow,
        centered: {
            display: 'flex',
            alignItems: 'center'
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        gridRow: {
            marginTop: theme.spacing(2)
        },
        subtitle: {
            display: 'flex',
            flexDirection: 'row'
        },
        button: {
            paddingTop: theme.spacing() + 4,
            paddingBottom: theme.spacing() + 4,
            width: '100%',
            marginTop: theme.spacing()
        },
        earnIcon: {
            marginRight: theme.spacing(),
            fontSize: 36
        },
        alert: {
            marginLeft: theme.spacing(2)
        },
        imageCard: (_a = {},
            _a[theme.breakpoints.up('sm')] = {
                width: 445,
                marginRight: theme.spacing(2),
                marginBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.only('xs')] = {
                width: 328
            },
            _a),
        bordered: {
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: colors_1.default.grayColor.toString(),
            borderRadius: '6px'
        },
        image: (_b = {
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: colors_1.default.grayColor.toString(),
                borderRadius: '6px',
                display: 'flex',
                position: 'relative'
            },
            _b[theme.breakpoints.up('sm')] = {
                height: 445,
                width: 445
            },
            _b[theme.breakpoints.only('xs')] = {
                height: 328,
                width: 328
            },
            _b),
        uploadCard: (_c = {
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: colors_1.default.grayColor.toString(),
                borderRadius: '6px'
            },
            _c[theme.breakpoints.up('md')] = {
                width: 623,
                marginRight: theme.spacing(2),
                marginBottom: theme.spacing(2)
            },
            _c[theme.breakpoints.only('sm')] = {
                width: 260
            },
            _c[theme.breakpoints.only('xs')] = {
                width: 260
            },
            _c),
        uploadGrid: (_d = {
                display: 'flex',
                padding: theme.spacing(),
                borderColor: '#6E7C8D',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderRadius: '6px',
                marginTop: 0
            },
            _d[theme.breakpoints.up('sm')] = {
                height: 500,
                flexDirection: 'row'
            },
            _d[theme.breakpoints.only('xs')] = {
                height: 656,
                width: 270,
                flexDirection: 'column'
            },
            _d),
        previewGridWrapper: (_e = {},
            _e[theme.breakpoints.only('xs')] = {
                maxWidth: '100%'
            },
            _e[theme.breakpoints.up('sm')] = {
                maxHeight: 429
            },
            _e[theme.breakpoints.only('xs')] = {
                maxHeight: 624,
                maxWidth: '100%'
            },
            _e),
        uploadedImg: (_f = {},
            _f[theme.breakpoints.up('sm')] = {
                maxHeight: 382
            },
            _f[theme.breakpoints.only('xs')] = {
                maxHeight: 582
            },
            _f),
        previewGrid: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(2),
            backgroundColor: (0, color_1.default)(colors_1.default.grayColor.hex()).alpha(0.2).rgb().string(),
            borderRadius: '6px',
            color: theme.palette.text.primary,
            height: '95%'
        },
        previewTextWrapper: {
            width: '100%'
        },
        previewText: {
            backgroundColor: 'rgba(0,0,0,0.77)',
            textAlign: 'center',
            color: '#ffffff',
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
            padding: '5px 0px'
        },
        selectGrid: (_g = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: theme.spacing(2),
                color: theme.palette.text.secondary,
                height: '100%'
            },
            _g[theme.breakpoints.only('xs')] = {
                maxWidth: '100%'
            },
            _g),
        progressText: {
            textAlign: 'center',
            paddingTop: theme.spacing()
        },
        cancelledText: {
            textAlign: 'center',
            paddingBottom: theme.spacing(2)
        },
        pointsText: {
            justifyContent: 'center',
            padding: theme.spacing(2),
            color: theme.palette.text.primary
        },
        errorText: {
            paddingBottom: theme.spacing(2)
        },
        uploadDetails: (_h = {
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: colors_1.default.grayColor.toString(),
                borderRadius: '6px'
            },
            _h[theme.breakpoints.up('sm')] = {
                height: 445,
                width: 445
            },
            _h[theme.breakpoints.only('xs')] = {
                height: 328,
                width: 328
            },
            _h),
        rules: (_j = {},
            _j[theme.breakpoints.down('xs')] = {
                display: 'flex',
                justifyContent: 'center'
            },
            _j),
        rulesLink: {
            display: 'flex',
            textDecoration: 'none'
        },
        selected: {
            backgroundColor: theme.palette.primary.dark,
            borderColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[6]
        },
        prizeSummary: {
            marginBottom: theme.spacing(2)
        },
        prizeContent: {
            marginBottom: theme.spacing(2)
        },
        prizeDescriptionLink: {
            display: 'flex',
            textDecoration: 'none',
            textTransform: 'uppercase'
        },
        enterTicketButton: {
            marginTop: theme.spacing(4)
        },
        eligibleGames: {
            marginTop: theme.spacing(4)
        },
        allEligibleGamesCard: (_k = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'stretch',
                alignItems: 'center',
                height: 432
            },
            _k[theme.breakpoints.down('lg')] = {
                height: 372
            },
            _k[theme.breakpoints.down('md')] = {
                height: 290
            },
            _k[theme.breakpoints.down('xs')] = {
                height: 432
            },
            _k)
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map